import { connect } from "react-redux";

import Actions from "../../Actions/Creators";
import App from "./Component/App";
import { change, destroy, reset } from "redux-form";
import Phi from "./../../Phi/Phi";
import Constants from "../../Phi/Constants";


const mapStateToProps = (state, ownProps) => {
    const userRole = Phi.User.roles();
    const userProfile = Phi.User.profile();

    return {        
        userId: userProfile && userProfile.user_id,
        organizationId: JSON.parse(Phi.Storage.getItem('organization')) ? JSON.parse(Phi.Storage.getItem('organization'))[0].org_id : null,
        
        isAuthenticated: state.auth.isAuthenticated,
        message: state.auth.message,
        isLoading: state.auth.isLoading,
        currentProgram: state.organization.currentProgram,
        history: state.organization.history,
        studentHeader: state.student.studentHeader,
        startNodeMap: state.organization.startNodeMap,
        roleType: userRole && userRole.length && userRole[0].role_type_id,

        episodeHeader: state.student.episodeHeader,
        episodeList: state.student.episodeList,
        episodeTotal: state.student.episodeTotal,

        studentHeader: state.student.clinicStudentHeader,
        studentList: state.student.clinicStudentList,
        studentTotal: state.student.clinicStudentTotal,

        episodeStats: state.student.episodeStats,

        programs: state.organization.programs,

        classes: state.organization.classes,

        metaMeds: state.organization.plusMetaMeds,
        metaSymp: state.organization.plusMetaSympt,
        metaTreat: state.organization.plusMetaTreat,
        metaVitals: state.organization.plusMetaVitals,

        vaccines: state.metadata.vaccineList,

        organizationContentId: state.organization.currentProgram 
            && state.organization.currentProgram.organization_custom_json 
            && state.organization.currentProgram.organization_custom_json.schoolContentID 
                ? state.organization.currentProgram.organization_custom_json.schoolContentID : state.organization.contentId,

        alerts: state.user.alerts['alert'],
        msg: state.user.alerts['msg'],

        messageUnreadCount: state.message.messageUnreadCount
    };
};

const mapDispatchToProps = dispatch => ({
    loginResponse: response => {
        dispatch(Actions.loginResponse(response));
    },
    // fetchStudentList: payload => dispatch(Actions.fetchStudentList(payload)),
    getReport: (reportType, config) => dispatch(Actions.getReport(reportType, config)),
    changeFieldValue: (field, value) => dispatch(change("customForm", field, value)),
    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    changePassword: newPassword => dispatch(Actions.changePassword(newPassword)),
    changeReportInReducer: billingId => dispatch(Actions.changeReportInReducer(billingId)),
    logoutUser: () => dispatch(Actions.logoutUser()), // Action to logout

    fetchEpisodeSearch: header => dispatch(Actions.fetchStudentEpisodeSearch(header)),
    fetchStudentSearch: header => dispatch(Actions.fetchClinicStudentSearch(header)),
    fetchEpisodeStats: inOrganizationId => dispatch(Actions.fetchClinicEpisodeStats(inOrganizationId)),

    resetEpisodeSearch: header =>
        dispatch(
            Actions.storeStudentEpisodeSearch({
                episodeList: [],
                episodeTotal: 0,
                episodeHeader: header
            })
        ),

    postStudentEpisode: (studentId, customJson, episodeType, newEpisodeHeader) =>
        dispatch(Actions.postStudentEpisodeInfo(studentId, customJson, episodeType, newEpisodeHeader)),

    fetchNurseMeta: () => dispatch(Actions.fetchNurseMeta()),

    getSchoolClasses: organization_id => dispatch(Actions.getSchoolClasses(organization_id)),

    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),

    fetchNurseMeta: () => dispatch(Actions.fetchNurseMeta()),
    fetchVaccination: () => dispatch(Actions.fetchVaccinationV2(1)),

    clearForm: () => dispatch(reset("customForm")),
    initializeForm: data => dispatch(Actions.initializeForm(data)),

    fetchAlerts: (userId) => dispatch(Actions.fetchAlerts(userId, Constants.alertTypeMap.ALERTS)),
    fetchMsgs: (userId) => dispatch(Actions.fetchAlerts(userId, Constants.alertTypeMap.MSG)),

    fetchMessageUnreadCount: (userId) => dispatch(Actions.fetchMessageUnreadCount(userId)),
    
    updateAlerts: (userId) => dispatch(Actions.updateAlerts(userId, Constants.alertTypeMap.ALERTS, Constants.alertStatus.SEND)),
    updateMsgs: (userId) => dispatch(Actions.updateAlerts(userId,  Constants.alertTypeMap.MSG, Constants.alertStatus.SEND)),

});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/Containers/AppContainer/index.js